"use client";

import { useTranslations } from "next-intl";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { FeedbackTypeEnum } from "@/types/feedback";

interface FeedbackTypeBadgeProps {
  type: FeedbackTypeEnum;
  className?: string;
}

const TYPE_STYLES: Record<FeedbackTypeEnum, { bg: string; text: string }> = {
  BUG_REPORT: {
    bg: "bg-semantic-error/15",
    text: "text-semantic-error",
  },
  SUGGESTION: {
    bg: "bg-semantic-link/15",
    text: "text-semantic-link",
  },
  COMPLIMENT: {
    bg: "bg-semantic-success/15",
    text: "text-semantic-success",
  },
  COMPLAINT: {
    bg: "bg-semantic-alert/15",
    text: "text-semantic-alert",
  },
};

export const FeedbackTypeBadge: React.FC<FeedbackTypeBadgeProps> = ({
  type,
  className,
}) => {
  const t = useTranslations("feedback");
  const style = TYPE_STYLES[type];

  return (
    <Badge
      variant="outline"
      size="sm"
      className={cn(
        "rounded-xs border-transparent",
        style.bg,
        style.text,
        className,
      )}
    >
      {t(`type.${type}`)}
    </Badge>
  );
};
